<template>
     <div>
        <template v-if="project">
            <v-card>
                <v-toolbar>
                    <v-toolbar-title class="toolbar-title">{{ project.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="addStuff" height="30" @click="clickBack()">Tillbaka</v-btn>
                    <template v-slot:extension>
                        <v-tabs v-model="tab" align-with-title  color="#cf2e2e">
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab>
                                ALLMÄNT
                            </v-tab>
                            <v-tab>
                                OBJEKT {{ countAssets }}
                            </v-tab>
                            <v-tab>
                                PROTOKOLL {{ countForms }}
                            </v-tab>
                        </v-tabs>
                    </template>
                </v-toolbar>
                <v-tabs-items v-model="tab">
                    <v-tab-item transition="false">
                        <template v-if="project.labels">
                            <div v-for="label in project.labels" :key="label">{{ label }}</div>
                        </template>
                        <v-container>
                            <v-row>
                                <v-col class="label">Projektnummer</v-col>
                                <v-col>{{ projectnumber }}</v-col>
                                <v-spacer></v-spacer>
                                <v-col class="label">Referensnummer</v-col>
                                <v-col>{{ project.referenceNo }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col class="label">Beskrivning</v-col>
                                <v-col> {{ project.description }}</v-col>
                                <v-spacer></v-spacer>
                                <v-col class="label"></v-col>
                                <v-col></v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-row>
                                        <v-col class="label">Kontakt</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="label">E-postadress</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col class="label">Telefonnummer</v-col>
                                    </v-row>
                                </v-col>
                                <v-col>
                                    <v-row>
                                        <v-col style="white-space: pre-wrap;">{{ contactName }}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col style="white-space: pre-wrap;">{{ contactEmailAddress }}</v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col style="white-space: pre-wrap;">{{ contactPhone }}</v-col>
                                    </v-row>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col>
                                    <v-row>
                                        <v-col class="label">Adress</v-col>
                                    </v-row>
                                </v-col>
                                <v-col>
                                    <v-row>
                                        <v-col style="white-space: pre-wrap;"><template v-if="project.location">{{ project.location.placeName }}</template></v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col></v-col>
                                <v-col></v-col>
                                <v-spacer></v-spacer>
                                <v-col class="label">Platsbeskrivning</v-col>
                                <v-col>{{ project.locationDescription}}</v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <div>
                            <v-container>
                                <v-row>
                                    <v-col>
                                        <select @change="assetLabelFilter($event)">
                                            <option value="-1">Alla etiketter</option>
                                            <option v-for="label in labels" :key="label" :value="label">{{ label }}</option>
                                        </select>
                                    </v-col>
                                    <v-col>
                                        <select @change="assetStateFilter($event)">
                                            <option value="all">Alla status</option>
                                            <option value="IN_USE">I drift</option>
                                            <option value="OUT_OF_ORDER">Ur funktion</option>
                                        </select>
                                    </v-col>
                                    <v-col>
                                        <select @change="assetTypeFilter($event)">
                                            <option value="-1">Alla objekttyper</option>
                                            <option v-for="type in assetTypes" :key="type" :value="type">{{ type }}</option>
                                        </select>
                                    </v-col>
                                </v-row>
                                <v-row class="header-row">
                                    <v-col>Objektnamn</v-col>
                                    <v-col>Objektnummer</v-col>
                                    <v-col>Etiketter</v-col>
                                    <v-col>Status</v-col>
                                    <v-col>Kundprojekt</v-col>
                                    <v-col>Plats</v-col>
                                </v-row>
                                <v-row v-for="(asset, index) in filteredAssets" :key="asset.id" @click="clickAsset(asset.id)" :class="index % 2 != 0 ? 'row-background' : ''">
                                    <v-col>{{ asset.name }}</v-col>
                                    <v-col>{{ asset.assetNo }}</v-col>
                                    <v-col>{{ asset.labels.join(' ')}}</v-col>
                                    <v-col>{{ asset.status }}</v-col>
                                    <v-col>{{ asset.customerProjectName }}</v-col>
                                    <v-col v-if="asset.location">{{ asset.location.placeName }}</v-col><v-col v-else></v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-tab-item>
                    <v-tab-item transition="false">
                        <div>
                            <v-container>
                                <v-row><!--
                                    <v-col>
                                        <select @change="filterManagerPresent($event)">
                                            <option value="all">CSM bägge</option>
                                            <option value="yes">CSM närvarande: Ja</option>
                                            <option value="no">CSM närvarande: Nej</option>
                                        </select>
                                    </v-col>-->
                                    <v-col>
                                        <select @change="filterFormType($event)">
                                            <option value="-1">Alla protokoll</option>
                                            <option v-for="type in formTypes" :key="type" :value="type">{{ type }}</option>
                                        </select>
                                    </v-col>
                                </v-row>
                                <v-row class="header-row">
                                    <v-col>Datum</v-col>
                                    <!--<v-col>Status</v-col>-->
                                    <v-col>Titel</v-col>
                                    <v-col>Kundprojekt</v-col>
                                </v-row>
                                <v-row v-for="(form, index) in filteredForms" :key="form.id" @click="clickForm(form.id)" :class="index % 2 != 0 ? 'row-background' : ''">
                                    <v-col>{{ form.date }}</v-col>
                                    <!--<v-col>{{ form.state }}</v-col>-->
                                    <v-col>{{ form.title }}</v-col>
                                    <v-col><template v-if="form.customerProjectNo">{{ form.customerProjectNo }}</template><template v-else>{{ form.customerProjectNoText }}</template> {{ form.customerProjectName }}</v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </template>
        <template v-else>
            <h1>Hi normal user</h1>
        </template>
        <div v-if="this.loading">
            <v-progress-linear
                indeterminate
                color="primary"
                height="2">
            </v-progress-linear>
        </div>
    </div>
</template>

<script>
export default {
    'name': 'Project',
    props: ['projectData', 'projectAssets', 'projectForms'],
    created() {
        if (this.projectData) this.project = this.projectData;
        if (this.projectAssets) this.assets = this.projectAssets;
        if (this.projectForms) this.forms = this.projectForms;
        if (!this.project) this.project = this.$customer.projects.find(project => project.id = this.$attrs.id); 
        if (!this.forms) this.forms = this.$forms.filter(form => form.customerProjectId == this.$attrs.id);
        if (!this.assets) this.assets = this.$assets.filter(asset => asset.customerProjectId == this.$attrs.id);
    },
    mounted() {
        this.filterAssets();
        this.filterForms();
    },
    data: () => ({
        loading: false,
        tabs: ['Allmänt','Objekt','Protokoll'],
        tab: null,
        filteredAssets: [],
        filteredForms: [],
        filter: { asset: {}, form: {}},
        project: null,
        assets: null,
        forms: null
    }),
    methods: {
        clickAsset(id) {
            let asset = this.assets && this.assets.find(asset => asset.id == id);
            this.$router.push({ name: 'AssetDetails', params: { asset: asset, id: id }});
        },
        clickForm(id) {
            //let form = this.forms && this.forms.find(form => form.id == id);
            this.$router.push({ name: 'FormDetails', params: { formId: id, id: id }});
        },
        clickBack() {
            this.$router.go(-1);
        },
        assetLabelFilter(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.asset.label = null;
            else this.filter.asset.label = filter;
            this.filterAssets();
        },
        assetTypeFilter(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.asset.assetType = null;
            else this.filter.asset.assetType = filter;
            this.filterAssets();
        },
        filterAssets() {
            let filteredAssets = JSON.parse(JSON.stringify(this.assets));
            if (this.filter.asset.label) {
                filteredAssets = filteredAssets.filter(asset => asset.labels.includes(this.filter.asset.label));
            }
            if (this.filter.asset.assetType) {
                filteredAssets = filteredAssets.filter(asset => asset.assetTypeName == this.filter.asset.assetType);
            }
            if (this.filter.asset.project) {
                if (this.filter.asset.project == 'none') filteredAssets = filteredAssets.filter(asset => asset.customerProjectName == null);
                else filteredAssets = filteredAssets.filter(asset => asset.customerProjectName == this.filter.asset.project);
            }
            if (this.filter.asset.state) {
                if (this.filter.asset.state != 'all') {
                    filteredAssets = filteredAssets.filter(asset => asset.state == this.filter.asset.state);
                }
            }
            this.filteredAssets = filteredAssets;
        },
        filterManagerPresent(event) {
            let filter = event.target.value;
            if (filter == 'all') this.filter.form.manager = null;
            else this.filter.form.manager = filter;
            this.filterForms();
        },
        filterFormType(event) {
            let filter = event.target.value;
            if (filter == '-1') this.filter.form.type = null;
            else this.filter.form.type = filter.toLowerCase();
            this.filterForms();
        },
        filterForms() {
            let filteredForms = JSON.parse(JSON.stringify(this.forms));
            if (this.filter.form.manager) {
                if (this.filter.form.manager == 'yes') filteredForms = filteredForms.filter(form => form.title.toLowerCase().includes('närvarande: ja'));
                else if (this.filter.form.manager == 'no') filteredForms = filteredForms.filter(form => form.title.toLowerCase().includes('närvarande: nej'));
            }
            if (this.filter.form.type) {
                filteredForms = filteredForms.filter(form => form.title && form.title.toLowerCase().includes(this.filter.form.type));
            }
            if (this.filter.form.project) {
                if (this.filter.form.project == 'none') filteredForms = filteredForms.filter(form => form.customerProjectName == null);
                else filteredForms = filteredForms.filter(form => form.customerProjectName == this.filter.form.project);
            }
            this.filteredForms = filteredForms;
        },
        assetStateFilter(event) {
            let filter = event.target.value;
            if (filter == 'all') this.filter.asset.state = null;
            else this.filter.asset.state = filter;
            this.filterAssets();
        },
    },
    computed: {
        projectnumber() {
            return this.project.projectNo || this.project.projectNoText;
        },
        assetTypes() {
            return [...new Set(this.assets.map(asset => asset.assetTypeName))];
        },
        labels() {
            let labels = [];
            this.assets.forEach(asset => {
                if (asset.labels && asset.labels.length > 0) {
                    asset.labels.forEach(label => {
                        if (!labels.includes(label)) labels.push(label);
                    });
                }
            });
            return labels;
        },
        countAssets() {
            return '(' + this.assets.length + ')';
        },
        countForms() {
            return '(' + this.forms.length + ')';
        },
        contactEmailAddress() {
            return this.project && this.project.jobContact && this.project.jobContact.emailAddress || ' ';
        },
        contactPhone() {
            return this.project && this.project.jobContact && this.project.jobContact.phoneNo || ' ';
        },
        contactName() {
            return this.project && this.project.jobContact && this.project.jobContact.name || ' ';
        },
        formTypes() {
            return [...new Set(this.forms.map(function(form) {
                if (form.title && form.title.toLowerCase().includes('shopinformation')) return 'Shopinformation';
                else if (form.title) return form.title;
            }))];
        }
    }
}
</script>

<style lang="scss" scoped>
    select {
        border: 1px solid grey;
        border-radius: 2px;
    }
    .label {
        color: grey;
        text-align: right;
    }
</style>